import classNames from './LevelChangeModal.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';

import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';

interface LevelChangeModalProps {
  show: boolean;
  status: string;
  onRefresh: () => void;
}

const LevelChangeModal = ({ show, status, onRefresh }: LevelChangeModalProps) => {
  const { t } = useTranslation();

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop className={classes(classNames.backdrop, `backdrop-${state}`)} />
            <AppModal className={classNames.appModal}>
              <div className={classes(classNames.modal, `fade-${state}`)}>
                <h2>{t('levelChanged')}</h2>
                <span className={classNames.description}>
                  {status === 'LEVEL_UP' ? t('levelChangedUp') : t('levelChangedDown')}
                </span>
                <span className={classes(classNames.description, classNames.noMargin)}>
                  {status === 'LEVEL_UP'
                    ? t('levelChangedUpDescription')
                    : t('levelChangedDownDescription')}
                </span>
                <span className={classes(classNames.description, classNames.bold)}>
                  {t('levelChangedDescription')}
                </span>

                <TheButton
                  className={classNames.closeBtn}
                  text={t('letsGo')}
                  shouldRecolor={false}
                  emitOnClick={onRefresh}
                />
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default LevelChangeModal;
